import React, { useContext } from 'react';
import './Sidebar.css';
import {
  DashboardOutlined,
  CalendarOutlined,
  NotificationOutlined,
  BookOutlined,
  UserOutlined,
  LockOutlined,
  SettingOutlined,
  ReadOutlined,
  BarChartOutlined,
  BankOutlined,
  DollarOutlined,
  SearchOutlined,
  StarOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  ApartmentOutlined,
  BranchesOutlined,
  OrderedListOutlined,
  VideoCameraAddOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../Auth/AuthContext';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { permissions } = useContext(AuthContext);
  const { role, branchId } = permissions;

  const { t } = useTranslation();

  


  const menuItems = [
    { iconName: "dashboard", tooltip: t('dashboard'), path: "/dashboard", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "myperformance", tooltip: t('myperformance'), path: "/myperformance", roles: ["student"] },
    { iconName: "leaverequest", tooltip: t('leaverequest'), path: "/studentleaverequest", roles: ["student"] },
    { iconName: "mybilling", tooltip: t('billing'), path: "/studentbilling", roles: ["student"] },
    { iconName: "annoucement", tooltip: t('announcement'), path: "/announcement", roles: ["admin", "teacher", "student", "superadmin"] },
    { iconName: "calendar", tooltip: t('calendar'), path: "/calendar", roles: ["admin", "teacher", "superadmin"] },
    { iconName: "classroom", tooltip: t('room'), path: "/classroom", roles: ["admin", "superadmin"] },
    { iconName: "allclasses", tooltip: t('Teacher Schedule'), path: "/allclasses", roles: ["admin", "superadmin"] },
    { iconName: "classeslist", tooltip: t('Class List'), path: "/classeslist", roles: ["admin", "superadmin"] },
    // { iconName: "quotation", tooltip: t('Quotation'), path: "/quotation", roles: ["admin", "superadmin"] },
    { iconName: "register", tooltip: t('register'), path: "/registrations", roles: ["admin", "superadmin"] },
    { 
      iconName: "sales", 
      tooltip: t('sales') + " Ekamai", 
      path: "/sales", 
      roles: ["admin", "superadmin"], 
      branchLimit: ["1"], 
    },
    { 
      iconName: "sales", 
      tooltip: t('sales') + " Ram", 
      path: "/sales-b2", 
      roles: ["admin", "superadmin"],  
      branchLimit: ["2"],  
    },
    { iconName: "adminpanel", tooltip: t('admin'), path: "/adminpanel", roles: ["admin", "superadmin"] },
    { iconName: "registrationlist", tooltip: t('attendance'), path: "/registrationlist", roles: ["admin", "superadmin"] },
    { iconName: "resource", tooltip: t('Resources'), path: "/resource", roles: ["admin", "superadmin"] },
    { iconName: "teacherresource", tooltip: t('Resources'), path: "/teacher-resource", roles: ["teacher"] },
    { iconName: "accounting", tooltip: t('accounting'), path: "/accounting", roles: ["superadmin", "admin"] },
    { iconName: "report", tooltip: t('report'), path: "/report", roles: ["superadmin"] },
    { iconName: "teacherhoursadmin", tooltip: t('tutor_hours'), path: "/teacher-hours-admin", roles: ["superadmin"] },
    { iconName: "teacherhours", tooltip: t('my_hours'), path: "/teacher-hours", roles: ["teacher"] },
    { iconName: "lessonplan", tooltip: t('Lesson Plan'), path: "/lessonplan", roles: ["teacher"] },
    { iconName: "usercontrolpage", tooltip: t('users'), path: "/usercontrolpage", roles: ["superadmin"] },
    { iconName: "branch", tooltip: t('Branch'), path: "/branch", roles: ["superadmin"] },
  ];

  const iconMapping = {
    "dashboard": DashboardOutlined,
    "myperformance": StarOutlined,
    "mybilling": FileTextOutlined,
    "leaverequest": ExclamationCircleOutlined,
    "annoucement": NotificationOutlined,
    "calendar": CalendarOutlined,
    "subject": BookOutlined,
    "teacher": UserOutlined,
    "classroom": ApartmentOutlined,
    "allclasses": ReadOutlined,
    "classeslist": OrderedListOutlined,
    "quotation": FileTextOutlined,
    "register": ShopOutlined,
    "sales": ShoppingCartOutlined,
    "adminpanel": SettingOutlined,
    "resource": VideoCameraAddOutlined,
    "teacherresource": VideoCameraAddOutlined,
    "accounting": BankOutlined,
    "report": BarChartOutlined,
    "teacherhoursadmin": SearchOutlined,
    "teacherhours": DollarOutlined,
    "lessonplan": AppstoreOutlined,
    "registrationlist": LineChartOutlined,
    "usercontrolpage": LockOutlined,
    "branch": BranchesOutlined,
  };

const filteredMenuItems = menuItems.filter(item => {
  if (role === "superadmin") {
    return item.roles.includes("superadmin"); // always show for superadmin
  }

  if (item.branchLimit && !item.branchLimit.includes(String(branchId))) {
    return false;
  }

  return item.roles.includes(role);
});


  return (
    <div className="modern-sidebar">
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {filteredMenuItems.map((item, index) => {
            const IconComponent = iconMapping[item.iconName];
            return (
              <li key={index} className="sidebar-item">
                <NavLink 
                  to={item.path} 
                  className={({isActive}) => 
                    isActive ? "sidebar-link active" : "sidebar-link"
                  }
                >
                  <div className="sidebar-icon-container">
                    <IconComponent className="sidebar-icon" />
                  </div>
                  <span className="sidebar-label">{item.tooltip}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;